import React from "react";
import "styled-components/macro";
import { DisplayStratificationValue, Group } from "@madie/madie-models";
import TestCaseStratificationRow from "./TestCaseStratificationRow";

export interface TestCaseStratificationProps {
  strataCode: string;
  isTestCaseExecuted?: boolean;
  setIsTestCaseExecuted?: (isTestCaseExecuted: boolean) => void;
  stratification: DisplayStratificationValue;
  stratificationCount: number;
  populationBasis: string;
  showExpected?: boolean;
  disableExpected?: boolean;
  onStratificationChange: (
    stratification: DisplayStratificationValue,
    stratId: string
  ) => void;
  groupsStratificationAssociationMap?: any;
  group?: Group;
  content: string;
}

const TestCaseStratification = ({
  strataCode,
  isTestCaseExecuted,
  setIsTestCaseExecuted,
  stratification,
  stratificationCount,
  populationBasis,
  disableExpected = false,
  onStratificationChange,
  groupsStratificationAssociationMap,
  group,
  content,
}: TestCaseStratificationProps) => {
  let associations = groupsStratificationAssociationMap
    ? groupsStratificationAssociationMap[stratification?.id]
    : [];
  if (!associations && stratification?.id.includes("Stratification_")) {
    const stratObjectId = group?.stratifications?.find(
      (strat) => strat.displayId === stratification?.id
    )?.id;
    associations = groupsStratificationAssociationMap
      ? groupsStratificationAssociationMap[stratObjectId]
      : [];
  }

  const associatedPopulationValues = stratification?.populationValues?.filter(
    (pop) => associations?.includes(pop.name)
  );
  return (
    <React.Fragment key={`fragment-key-${strataCode}`}>
      {associatedPopulationValues?.map((strat, index) => {
        return (
          <TestCaseStratificationRow
            stratification={strat} //actuall a population value
            stratificationCount={stratificationCount}
            stratId={stratification.id}
            strataCode={strataCode}
            isTestCaseExecuted={isTestCaseExecuted}
            setIsTestCaseExecuted={setIsTestCaseExecuted}
            populationBasis={populationBasis}
            disableExpected={disableExpected}
            onStratificationChange={onStratificationChange}
            content={content}
          />
        );
      })}
    </React.Fragment>
  );
};

export default TestCaseStratification;
